import React from 'react';
import { Box, Typography } from '@heycater/design-system';
import { useMediaQuery } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import ScrollToTopButton from 'shared/components/ScrollToTopButton';
import PartnerLogoBubbles from 'static_pages/marketing_pages/components/PartnerLogoBubbles';
import Container from 'system/components/Container';

function PartnersCTA() {
  const { t } = useTranslation('static_pages');
  const mobile = useMediaQuery((theme) => theme.breakpoints.down('xs'));

  return (
    <Box py={4} sm={{ pt: 6 }}>
      <Container size="sm">
        <Box as="header" textAlign="center">
          <Typography variant="h3" mb={2}>
            {t('marketingPages.partnersCTA.title.a')}{' '}
            <Typography variant="inherit" slab color="secondary">
              {t('marketingPages.partnersCTA.title.b')}
            </Typography>{' '}
          </Typography>
          <Typography variant="subtitle2">
            {t('marketingPages.partnersCTA.subtitle')}
          </Typography>
        </Box>
        <PartnerLogoBubbles />

        {mobile && (
          <Box pt={{ xs: 2, sm: 4 }} pb={2} textAlign="center">
            <ScrollToTopButton>
              {t('common:labels.findCaterers')}
            </ScrollToTopButton>
          </Box>
        )}
      </Container>
    </Box>
  );
}

export default PartnersCTA;
